import { ReactNode } from "react";
import BootstrapBtn, { ButtonProps } from "react-bootstrap/Button";
import { ButtonVariant } from "react-bootstrap/esm/types";
import classnames from "classnames";

import "./Button.scss";
import { Icon } from "../../icon";

interface Props extends Omit<ButtonProps, "variant"> {
  children?: ReactNode;
  variant?: ButtonVariant | "confirm";
  loading?: boolean;
}

export const Button = ({
  loading = false,
  className,
  children,
  ...restProps
}: Props) => {
  const classNames = classnames(className, "btn-custom");
  return (
    <BootstrapBtn {...restProps} className={classNames}>
      {!loading && <>{children}</>}
      {loading && <Icon.Loading />}
    </BootstrapBtn>
  );
};
